import React from 'react';
import '../styles/Footer.css';
import facebookIcon from '../assets/facebook.png';
import instagramIcon from '../assets/instagram.png';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <h2>燒石鼎</h2>
      <p>地址：汐止區大同路二段565號（汐止火車站對面）</p>
      <p>電話：（02）2648-7777</p>
      <p>
        <a 
          href="line://ti/p/@472ldhkc" 
          className="line-link"
        >
          Line 好友募集中👯‍♀️ ID:@472ldhkc
        </a>
      </p>
      <p>加入 Line 好友享優惠，使用線上點餐節省等候時間，還能獲得鍋物折價券！</p>
      <div className="business-hours">
        <h3>營業時間</h3>
        <p>星期一: 11:00 – 00:00</p>
        <p>星期二: 11:00 – 00:00</p>
        <p>星期三: 11:00 – 00:00</p>
        <p>星期四: 11:00 – 00:00</p>
        <p>星期五: 11:00 – 00:00</p>
        <p>星期六: 11:00 – 00:00</p>
        <p>星期日: 11:00 – 22:00</p>
      </div>
      <div className="social-icons">
        <a href="https://www.facebook.com/p/%E7%87%92%E7%9F%B3%E9%BC%8E-SHARE-STONE-100092494385790/" target="_blank" rel="noopener noreferrer">
          <img src={facebookIcon} alt="Facebook" className="social-icon" />
        </a>
        <a href="https://www.instagram.com/share__stone/" target="_blank" rel="noopener noreferrer">
          <img src={instagramIcon} alt="Instagram" className="social-icon" />
        </a>
      </div>
      <p>#外送平台限時優惠中 #UberEats #FoodPanda</p>
      <p>#燒石鼎 #職人の石頭火鍋 #台式火鍋 #170元起 #加入line好友饗優惠 #外帶火鍋 #汐止美食 #汐止宵夜 #汐止火車站 #飲料白飯自助區 #石頭火鍋 #麻辣火鍋 #豬油拌飯 #榴蓮冰</p>
    </footer>
  );
}

export default Footer;
